import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { BRAND, SOCIALS } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-border bg-obsidian">
    <div className="mx-auto max-w-[1500px] px-6 py-20 md:px-12 md:py-28">
      <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
        <div className="md:col-span-6">
          <p className="font-display text-5xl leading-[1.05] text-white sm:text-6xl">
            Let's build your
            <br />
            <span className="italic text-sand">dream backyard.</span>
          </p>
          <Link
            to="/projects#contact"
            data-testid="footer-cta"
            className="mt-10 inline-flex items-center gap-2 bg-white px-8 py-4 text-[13px] uppercase tracking-[0.18em] text-obsidian transition-colors duration-300 hover:bg-ember"
          >
            Start a project <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="md:col-span-3">
          <p className="mb-6 text-[11px] uppercase tracking-[0.25em] text-sand">Get in touch</p>
          <a href={BRAND.phoneHref} className="flex items-center gap-3 py-2 text-white transition-colors hover:text-ember">
            <Phone className="h-4 w-4 text-sand" /> {BRAND.phone}
          </a>
          <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 py-2 text-white transition-colors hover:text-ember break-all">
            <Mail className="h-4 w-4 text-sand shrink-0" /> {BRAND.email}
          </a>
          <p className="mt-4 text-sm text-sand">{BRAND.location}</p>
        </div>

        <div className="md:col-span-3">
          <p className="mb-6 text-[11px] uppercase tracking-[0.25em] text-sand">Follow</p>
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${s.label.toLowerCase()}`}
              className="group flex items-center justify-between border-b border-border py-3 text-white transition-colors hover:text-ember"
            >
              {s.label}
              <ArrowUpRight className="h-4 w-4 text-sand transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          ))}
        </div>
      </div>

      <div className="mt-20 flex flex-col items-start justify-between gap-4 border-t border-border pt-8 text-[12px] uppercase tracking-[0.15em] text-sand sm:flex-row sm:items-center">
        <img src={BRAND.logo} alt="101 Contractor LLC" className="h-16 w-auto rounded-lg" />
        <span>{BRAND.slogan}</span>
        <span>© {new Date().getFullYear()} {BRAND.name}</span>
      </div>
    </div>
  </footer>
);
